import { PageHeader } from "@/components/common/PageHeader";
import { Reveal } from "@/components/common/Reveal";
import { Icon } from "@/components/common/Icon";
import { TellUsButton } from "@/components/common/TellUsButton";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

// Reusable audience landing page (Employers / Candidates).
export const AudiencePage = ({ testId, overline, title, subtitle, points, verticals, ctaPath, ctaLabel }) => (
  <div data-testid={testId}>
    <PageHeader overline={overline} title={title} subtitle={subtitle} tone="navy" />

    <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-24">
      <div className="grid gap-px overflow-hidden rounded-2xl border border-border bg-border md:grid-cols-3">
        {points.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07} className="bg-white p-8">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50 text-blue-600">
              <Icon name={p.icon} className="h-5 w-5" />
            </span>
            <h3 className="mt-5 font-heading text-lg font-bold text-slate-900">{p.title}</h3>
            <p className="mt-2 leading-relaxed text-slate-600">{p.body}</p>
          </Reveal>
        ))}
      </div>
    </section>

    <section className="border-t border-border bg-blue-50 py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <h2 className="font-heading text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl">
            Where we can help
          </h2>
        </Reveal>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {verticals.map((v) => (
            <Reveal key={v.id} className="rounded-2xl border border-border bg-white p-8">
              <p className="overline">{v.short}</p>
              <h3 className="mt-3 font-heading text-xl font-bold text-slate-900">{v.name}</h3>
              <div className="mt-5 flex flex-wrap gap-2">
                {v.services.map((s) => (
                  <span key={s.name} className="rounded-full border border-border bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-600">
                    {s.name}
                  </span>
                ))}
              </div>
              <Link
                to={`/services#${v.id}`}
                className="group mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900"
              >
                Explore {v.short}
                <ArrowUpRight className="h-4 w-4 text-blue-600 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-12">
          <TellUsButton size="lg" label={ctaLabel} testId={`${ctaPath}-cta`} />
        </Reveal>
      </div>
    </section>
  </div>
);
